import React, { useEffect } from 'react'
import ButtonClose from '../../atoms/button-close/button-close'

import './modalTerms.scss'
import { triggerTag } from '../../../utils/taggeo'
import { getTerms } from './termsData'

const ModalTerms = ({ close }: { close: () => void }) => {
  useEffect(() => {
    triggerTag('8A', { label: 'Términos y condiciones' })
  }, [])
  const TERMS = getTerms()
  return (
    <div className="f-modal-terms">
      <ButtonClose
        className="f-modal-terms__close "
        onClick={close}
        title="cerrar modal y regresar al home"
      />
      <article className="f-modal-terms__container">
        <h2 className="f-modal-terms__title">Términos y condiciones</h2>
        <div className="f-modal-terms__scroller">
          <ul>
            {TERMS.map((item, index) => {
              return <li key={index}>{item}</li>
            })}
          </ul>
        </div>
      </article>
    </div>
  )
}

export default ModalTerms
